export default __webpack_public_path__ + "static/assets/90fb0caa5319c39b24946476dd32bb0d.svg";